import React from 'react'
import { searchIcon } from '../../assets'
import './search.scss'

type SearchInterface = {
    inputRef?: React.RefObject<HTMLInputElement> | undefined
    showIcon?: boolean
    placeholder: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    value?: string
    id?: string
    iconPos?: 'right' | 'left'
    iconSize?: string
    iconColor?: string
    style?: 'default' | 'rounded' | 'compact'
    onSearchHandler?: () => void
    onBlur?: () => void
}

export const Search: React.FC<SearchInterface> = ({
    inputRef,
    style = 'default',
    iconPos = 'right',
    iconSize,
    iconColor,
    onSearchHandler,
    ...props
}) => {
    const searchInput = (
        <input
            ref={inputRef}
            type="text"
            className={`search-input--${style}`}
            onKeyDown={({ key }) => key === 'Enter' && onSearchHandler?.()}
            name="query"
            maxLength={50}
            {...props}
            onBlur={props.onBlur}
        />
    )

    const searchInputBuild =
        iconPos === 'left' ? (
            <>
                <div
                    className="secondary-icon"
                    style={{ height: `${iconSize || 30}px` }}
                    onClick={onSearchHandler}
                    aria-label="search-icon"
                >
                    {searchIcon({ size: iconSize, color: iconColor })}
                </div>{' '}
                {searchInput}
            </>
        ) : (
            <>
                {searchInput}{' '}
                <div className="search-input--btn" id="search-input-btn">
                    {searchIcon({})}
                </div>
            </>
        )

    return <span className="search--input">{searchInputBuild}</span>
}
